import { useTranslation } from "next-i18next";
import React from "react";
import { Col, Row } from "react-bootstrap";
import RocketSVG from "../../../public/icons/team/rocket.svg";
import TeamSectionHeader from "../Text/TeamSectionHeader";
import { HTMLRowProps } from "../../../types/htmlElementTypes";

interface Props extends HTMLRowProps { };

const MeetTheTeam = ({ ...htmlProps }: Props) => {
  const { t } = useTranslation("team");

  return (
    <div {...htmlProps} className="d-flex justify-content-center">
      <Row className="d-flex justify-content-around w-100">
        <Col xs="12" sm="8" md="6">
          <TeamSectionHeader
            subTitle={t("meetTheTeam.subTitle")}
            title={t("meetTheTeam.title")}
            text={t("meetTheTeam.text")}
            className="p-0"
          />
        </Col>
        <Col
          xs="auto"
          className="d-flex justify-content-center align-items-center"
        >
          <RocketSVG heigh={100} width={100} />
        </Col>
      </Row>
    </div>
  );
};

export default MeetTheTeam;
